"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PromiseQueue_1 = require("./Utils/PromiseQueue");
class WebComponentManager {
    static registerWebComponent(webComponent) {
        const assignedId = this.embeddingIndex;
        this.webComponents.set(assignedId, webComponent);
        this.embeddingIndex++;
        return assignedId;
    }
    static unregisterWebComponent(embeddingIndex) {
        this.webComponents.delete(embeddingIndex);
    }
    // Methods below only used for testing
    static getWebComponents() {
        const webComponentsCloned = new Map();
        // a shallow copy is good enough
        this.webComponents.forEach((webComponent, embeddingIndex) => {
            webComponentsCloned.set(embeddingIndex, webComponent);
        });
        return webComponentsCloned;
    }
    static synchronizeRender(func) {
        const promise = this.queue.add(func);
        this.queue.poll();
        return promise;
    }
    static clear() {
        this.webComponents.clear();
    }
}
exports.WebComponentManager = WebComponentManager;
// This contains a static counter & a map that keeps track of the webComponents embedded.
WebComponentManager.embeddingIndex = 0;
WebComponentManager.webComponents = new Map();
WebComponentManager.queue = new PromiseQueue_1.PromiseQueue();
//# sourceMappingURL=WebComponentManager.js.map